import React from 'react';

const NotesButton = ({ onClick, notesOpen, noteText }) => {
  const notesButton = {
    padding: '6px 8px',
    cursor: 'pointer',
    backgroundColor: '#489EA3',
    fontWeight: 'bold',
    color: 'white',
    border: 'none',
    width: '120px',
    marginBottom: '6px'
  };

  return (
    <button
      style={notesButton}
      onClick={onClick}
      aria-expanded={notesOpen}
      type="button"
      title={(noteText != "") ? "Edit your note for this match." : "Add a note to this match."}
    >
      {(noteText != "") ? "EDIT NOTE" : "ADD NOTE"}
    </button>
  );
};

export default NotesButton;
